<div class="envio-firmante-card" cdkDrag>
  <div class="envio-firmante-card__row">
    <span class="orden">{{ ordenDisplay }}</span>
    <div class="envio-firmante-card__flex">
      <div class="td-drag" cdkDragHandle>
        <svg class="icon-draggable" aria-hidden="true">
          <use xlink:href="#icon-draggable"></use>
        </svg>
      </div>
      <div class="envio-firmante-card__registro" [class.envio-firmante-card__registro--validador]="firmante.esValidador">
        <div
          class="envio-firmante-card__avatar"
          [class.envio-firmante-card__avatar--validador]="firmante.esValidador"
          [style.background-color]="firmante.esValidador ? null : firmante.color.border">
          <span *ngIf="firmante.esValidador" class="envio-firmante-card__validador">V</span>
          <svg *ngIf="!firmante.esValidador" class="envio-firmante-card__icono-usuario" aria-hidden="true">
            <use xlink:href="#icon-user"></use>
          </svg>
        </div>

        <div class="envio-firmante-card__campos">
        <div class="envio-firmante-card__campo">
          <input
            [id]="'nombre-' + firmante.codigo"
            type="text"
            aria-label="Nombre"
            [value]="firmante.nombre"
            (input)="actualizarCampo('nombre', $any($event.target).value)" />
        </div>
        <div class="envio-firmante-card__campo">
          <input
            [id]="'apellido1-' + firmante.codigo"
            type="text"
            aria-label="Apellido 1"
            [value]="firmante.apellido1"
            (input)="actualizarCampo('apellido1', $any($event.target).value)" />
        </div>
        <div class="envio-firmante-card__campo">
          <input
            [id]="'apellido2-' + firmante.codigo"
            type="text"
            aria-label="Apellido 2"
            [value]="firmante.apellido2"
            (input)="actualizarCampo('apellido2', $any($event.target).value)" />
        </div>
        <div class="envio-firmante-card__campo envio-firmante-card__campo--email" *ngIf="mostrarEmail">
          <input
            [id]="'email-' + firmante.codigo"
            type="text"
            inputmode="email"
            autocomplete="email"
            aria-label="E-mail"
            [class.errorInput]="emailTieneError"
            [value]="firmante.email"
            (input)="onEmailInput($any($event.target).value)"
            (blur)="marcarEmailTocado()" />
          <span class="texto-validacion" *ngIf="emailTieneError">
            {{ mensajeErrorEmail }}
          </span>
        </div>
        <div class="envio-firmante-card__campo envio-firmante-card__campo--telefono" *ngIf="mostrarTelefono">
          <input
            [id]="'telefono-' + firmante.codigo"
            type="text"
            inputmode="tel"
            autocomplete="tel"
            aria-label="Telefono"
            [class.errorInput]="telefonoTieneError"
            [value]="firmante.telefono"
            (input)="onTelefonoInput($any($event.target).value)"
            (blur)="marcarTelefonoTocado()" />
          <span class="texto-validacion" *ngIf="telefonoTieneError">
            {{ mensajeErrorTelefono }}
          </span>
        </div>
      </div>

      <div class="envio-firmante-card__acciones">
        <button
          type="button"
          class="envio-firmante-card__buscar"
          [attr.aria-label]="'Buscar empleado para ' + firmante.desc"
          (click)="buscarEmpleado.emit()">
          <svg aria-hidden="true">
            <use xlink:href="#hs-buscar-empleado"></use>
          </svg>
        </button>
        <button type="button" class="envio-firmante-card__editar" (click)="editarOtrosDatos.emit()">
          Editar otros datos
        </button>
        <button
          *ngIf="puedeEliminar"
          type="button"
          class="envio-firmante-card__eliminar"
          [attr.aria-label]="'Quitar ' + firmante.desc"
          (click)="eliminar.emit()">
          <svg aria-hidden="true">
            <use xlink:href="#hs-bin"></use>
          </svg>
        </button>
        <span *ngIf="!puedeEliminar" class="envio-firmante-card__sin-eliminar" aria-hidden="true">&nbsp;</span>
        </div>
      </div>
    </div>
  </div>
</div>
